import { IArtistResponse } from '#/types/API/artists';
import withMatcher from '#/utils/withMatcher';

export const createActionArtistRelatedSetRelatedArtists = withMatcher(
  (payload: IArtistResponse[]) => {
    return {
      type: 'artist_related/set_related_artists',
      payload,
    };
  }
);

export const createActionArtistRelatedStartLoading = withMatcher(() => {
  return {
    type: 'artist_related/start_loading',
  };
});

export const createActionArtistRelatedStopLoading = withMatcher(() => {
  return {
    type: 'artist_related/stop_loading',
  };
});

export const createActionArtistRelatedError = withMatcher(() => {
  return {
    type: 'artist_related/error_details',
  };
});

export const createActionArtistRelatedReset = withMatcher(() => {
  return {
    type: 'artist_related/reset',
  };
});
